(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["SellerCard"] = factory(require("@fiverr/globals"), require("react"), require("react-dom"));
	else
		root["SellerCard"] = factory(root["@fiverr/globals"], root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/seller_card/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "lVK7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/cOS":
/***/ (function(module, exports) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

function getDefaultWhiteList () {
  // 白名单值说明：
  // true: 允许该属性
  // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
  // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
  // 除上面列出的值外均表示不允许
  var whiteList = {};

  whiteList['align-content'] = false; // default: auto
  whiteList['align-items'] = false; // default: auto
  whiteList['align-self'] = false; // default: auto
  whiteList['alignment-adjust'] = false; // default: auto
  whiteList['alignment-baseline'] = false; // default: baseline
  whiteList['all'] = false; // default: depending on individual properties
  whiteList['anchor-point'] = false; // default: none
  whiteList['animation'] = false; // default: depending on individual properties
  whiteList['animation-delay'] = false; // default: 0
  whiteList['animation-direction'] = false; // default: normal
  whiteList['animation-duration'] = false; // default: 0
  whiteList['animation-fill-mode'] = false; // default: none
  whiteList['animation-iteration-count'] = false; // default: 1
  whiteList['animation-name'] = false; // default: none
  whiteList['animation-play-state'] = false; // default: running
  whiteList['animation-timing-function'] = false; // default: ease
  whiteList['azimuth'] = false; // default: center
  whiteList['backface-visibility'] = false; // default: visible
  whiteList['background'] = true; // default: depending on individual properties
  whiteList['background-attachment'] = true; // default: scroll
  whiteList['background-clip'] = true; // default: border-box
  whiteList['background-color'] = true; // default: transparent
  whiteList['background-image'] = true; // default: none
  whiteList['background-origin'] = true; // default: padding-box
  whiteList['background-position'] = true; // default: 0% 0%
  whiteList['background-repeat'] = true; // default: repeat
  whiteList['background-size'] = true; // default: auto
  whiteList['baseline-shift'] = false; // default: baseline
  whiteList['binding'] = false; // default: none
  whiteList['bleed'] = false; // default: 6pt
  whiteList['bookmark-label'] = false; // default: content()
  whiteList['bookmark-level'] = false; // default: none
  whiteList['bookmark-state'] = false; // default: open
  whiteList['border'] = true; // default: depending on individual properties
  whiteList['border-bottom'] = true; // default: depending on individual properties
  whiteList['border-bottom-color'] = true; // default: current color
  whiteList['border-bottom-left-radius'] = true; // default: 0
  whiteList['border-bottom-right-radius'] = true; // default: 0
  whiteList['border-bottom-style'] = true; // default: none
  whiteList['border-bottom-width'] = true; // default: medium
  whiteList['border-collapse'] = true; // default: separate
  whiteList['border-color'] = true; // default: depending on individual properties
  whiteList['border-image'] = true; // default: none
  whiteList['border-image-outset'] = true; // default: 0
  whiteList['border-image-repeat'] = true; // default: stretch
  whiteList['border-image-slice'] = true; // default: 100%
  whiteList['border-image-source'] = true; // default: none
  whiteList['border-image-width'] = true; // default: 1
  whiteList['border-left'] = true; // default: depending on individual properties
  whiteList['border-left-color'] = true; // default: current color
  whiteList['border-left-style'] = true; // default: none
  whiteList['border-left-width'] = true; // default: medium
  whiteList['border-radius'] = true; // default: 0
  whiteList['border-right'] = true; // default: depending on individual properties
  whiteList['border-right-color'] = true; // default: current color
  whiteList['border-right-style'] = true; // default: none
  whiteList['border-right-width'] = true; // default: medium
  whiteList['border-spacing'] = true; // default: 0
  whiteList['border-style'] = true; // default: depending on individual properties
  whiteList['border-top'] = true; // default: depending on individual properties
  whiteList['border-top-color'] = true; // default: current color
  whiteList['border-top-left-radius'] = true; // default: 0
  whiteList['border-top-right-radius'] = true; // default: 0
  whiteList['border-top-style'] = true; // default: none
  whiteList['border-top-width'] = true; // default: medium
  whiteList['border-width'] = true; // default: depending on individual properties
  whiteList['bottom'] = false; // default: auto
  whiteList['box-decoration-break'] = true; // default: slice
  whiteList['box-shadow'] = true; // default: none
  whiteList['box-sizing'] = true; // default: content-box
  whiteList['box-snap'] = true; // default: none
  whiteList['box-suppress'] = true; // default: show
  whiteList['break-after'] = true; // default: auto
  whiteList['break-before'] = true; // default: auto
  whiteList['break-inside'] = true; // default: auto
  whiteList['caption-side'] = false; // default: top
  whiteList['chains'] = false; // default: none
  whiteList['clear'] = true; // default: none
  whiteList['clip'] = false; // default: auto
  whiteList['clip-path'] = false; // default: none
  whiteList['clip-rule'] = false; // default: nonzero
  whiteList['color'] = true; // default: implementation dependent
  whiteList['color-interpolation-filters'] = true; // default: auto
  whiteList['column-count'] = false; // default: auto
  whiteList['column-fill'] = false; // default: balance
  whiteList['column-gap'] = false; // default: normal
  whiteList['column-rule'] = false; // default: depending on individual properties
  whiteList['column-rule-color'] = false; // default: current color
  whiteList['column-rule-style'] = false; // default: medium
  whiteList['column-rule-width'] = false; // default: medium
  whiteList['column-span'] = false; // default: none
  whiteList['column-width'] = false; // default: auto
  whiteList['columns'] = false; // default: depending on individual properties
  whiteList['contain'] = false; // default: none
  whiteList['content'] = false; // default: normal
  whiteList['counter-increment'] = false; // default: none
  whiteList['counter-reset'] = false; // default: none
  whiteList['counter-set'] = false; // default: none
  whiteList['crop'] = false; // default: auto
  whiteList['cue'] = false; // default: depending on individual properties
  whiteList['cue-after'] = false; // default: none
  whiteList['cue-before'] = false; // default: none
  whiteList['cursor'] = false; // default: auto
  whiteList['direction'] = false; // default: ltr
  whiteList['display'] = true; // default: depending on individual properties
  whiteList['display-inside'] = true; // default: auto
  whiteList['display-list'] = true; // default: none
  whiteList['display-outside'] = true; // default: inline-level
  whiteList['dominant-baseline'] = false; // default: auto
  whiteList['elevation'] = false; // default: level
  whiteList['empty-cells'] = false; // default: show
  whiteList['filter'] = false; // default: none
  whiteList['flex'] = false; // default: depending on individual properties
  whiteList['flex-basis'] = false; // default: auto
  whiteList['flex-direction'] = false; // default: row
  whiteList['flex-flow'] = false; // default: depending on individual properties
  whiteList['flex-grow'] = false; // default: 0
  whiteList['flex-shrink'] = false; // default: 1
  whiteList['flex-wrap'] = false; // default: nowrap
  whiteList['float'] = false; // default: none
  whiteList['float-offset'] = false; // default: 0 0
  whiteList['flood-color'] = false; // default: black
  whiteList['flood-opacity'] = false; // default: 1
  whiteList['flow-from'] = false; // default: none
  whiteList['flow-into'] = false; // default: none
  whiteList['font'] = true; // default: depending on individual properties
  whiteList['font-family'] = true; // default: implementation dependent
  whiteList['font-feature-settings'] = true; // default: normal
  whiteList['font-kerning'] = true; // default: auto
  whiteList['font-language-override'] = true; // default: normal
  whiteList['font-size'] = true; // default: medium
  whiteList['font-size-adjust'] = true; // default: none
  whiteList['font-stretch'] = true; // default: normal
  whiteList['font-style'] = true; // default: normal
  whiteList['font-synthesis'] = true; // default: weight style
  whiteList['font-variant'] = true; // default: normal
  whiteList['font-variant-alternates'] = true; // default: normal
  whiteList['font-variant-caps'] = true; // default: normal
  whiteList['font-variant-east-asian'] = true; // default: normal
  whiteList['font-variant-ligatures'] = true; // default: normal
  whiteList['font-variant-numeric'] = true; // default: normal
  whiteList['font-variant-position'] = true; // default: normal
  whiteList['font-weight'] = true; // default: normal
  whiteList['grid'] = false; // default: depending on individual properties
  whiteList['grid-area'] = false; // default: depending on individual properties
  whiteList['grid-auto-columns'] = false; // default: auto
  whiteList['grid-auto-flow'] = false; // default: none
  whiteList['grid-auto-rows'] = false; // default: auto
  whiteList['grid-column'] = false; // default: depending on individual properties
  whiteList['grid-column-end'] = false; // default: auto
  whiteList['grid-column-start'] = false; // default: auto
  whiteList['grid-row'] = false; // default: depending on individual properties
  whiteList['grid-row-end'] = false; // default: auto
  whiteList['grid-row-start'] = false; // default: auto
  whiteList['grid-template'] = false; // default: depending on individual properties
  whiteList['grid-template-areas'] = false; // default: none
  whiteList['grid-template-columns'] = false; // default: none
  whiteList['grid-template-rows'] = false; // default: none
  whiteList['hanging-punctuation'] = false; // default: none
  whiteList['height'] = true; // default: auto
  whiteList['hyphens'] = false; // default: manual
  whiteList['icon'] = false; // default: auto
  whiteList['image-orientation'] = false; // default: auto
  whiteList['image-resolution'] = false; // default: normal
  whiteList['ime-mode'] = false; // default: auto
  whiteList['initial-letters'] = false; // default: normal
  whiteList['inline-box-align'] = false; // default: last
  whiteList['justify-content'] = false; // default: auto
  whiteList['justify-items'] = false; // default: auto
  whiteList['justify-self'] = false; // default: auto
  whiteList['left'] = false; // default: auto
  whiteList['letter-spacing'] = true; // default: normal
  whiteList['lighting-color'] = true; // default: white
  whiteList['line-box-contain'] = false; // default: block inline replaced
  whiteList['line-break'] = false; // default: auto
  whiteList['line-grid'] = false; // default: match-parent
  whiteList['line-height'] = false; // default: normal
  whiteList['line-snap'] = false; // default: none
  whiteList['line-stacking'] = false; // default: depending on individual properties
  whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
  whiteList['line-stacking-shift'] = false; // default: consider-shifts
  whiteList['line-stacking-strategy'] = false; // default: inline-line-height
  whiteList['list-style'] = true; // default: depending on individual properties
  whiteList['list-style-image'] = true; // default: none
  whiteList['list-style-position'] = true; // default: outside
  whiteList['list-style-type'] = true; // default: disc
  whiteList['margin'] = true; // default: depending on individual properties
  whiteList['margin-bottom'] = true; // default: 0
  whiteList['margin-left'] = true; // default: 0
  whiteList['margin-right'] = true; // default: 0
  whiteList['margin-top'] = true; // default: 0
  whiteList['marker-offset'] = false; // default: auto
  whiteList['marker-side'] = false; // default: list-item
  whiteList['marks'] = false; // default: none
  whiteList['mask'] = false; // default: border-box
  whiteList['mask-box'] = false; // default: see individual properties
  whiteList['mask-box-outset'] = false; // default: 0
  whiteList['mask-box-repeat'] = false; // default: stretch
  whiteList['mask-box-slice'] = false; // default: 0 fill
  whiteList['mask-box-source'] = false; // default: none
  whiteList['mask-box-width'] = false; // default: auto
  whiteList['mask-clip'] = false; // default: border-box
  whiteList['mask-image'] = false; // default: none
  whiteList['mask-origin'] = false; // default: border-box
  whiteList['mask-position'] = false; // default: center
  whiteList['mask-repeat'] = false; // default: no-repeat
  whiteList['mask-size'] = false; // default: border-box
  whiteList['mask-source-type'] = false; // default: auto
  whiteList['mask-type'] = false; // default: luminance
  whiteList['max-height'] = true; // default: none
  whiteList['max-lines'] = false; // default: none
  whiteList['max-width'] = true; // default: none
  whiteList['min-height'] = true; // default: 0
  whiteList['min-width'] = true; // default: 0
  whiteList['move-to'] = false; // default: normal
  whiteList['nav-down'] = false; // default: auto
  whiteList['nav-index'] = false; // default: auto
  whiteList['nav-left'] = false; // default: auto
  whiteList['nav-right'] = false; // default: auto
  whiteList['nav-up'] = false; // default: auto
  whiteList['object-fit'] = false; // default: fill
  whiteList['object-position'] = false; // default: 50% 50%
  whiteList['opacity'] = false; // default: 1
  whiteList['order'] = false; // default: 0
  whiteList['orphans'] = false; // default: 2
  whiteList['outline'] = false; // default: depending on individual properties
  whiteList['outline-color'] = false; // default: invert
  whiteList['outline-offset'] = false; // default: 0
  whiteList['outline-style'] = false; // default: none
  whiteList['outline-width'] = false; // default: medium
  whiteList['overflow'] = false; // default: depending on individual properties
  whiteList['overflow-wrap'] = false; // default: normal
  whiteList['overflow-x'] = false; // default: visible
  whiteList['overflow-y'] = false; // default: visible
  whiteList['padding'] = true; // default: depending on individual properties
  whiteList['padding-bottom'] = true; // default: 0
  whiteList['padding-left'] = true; // default: 0
  whiteList['padding-right'] = true; // default: 0
  whiteList['padding-top'] = true; // default: 0
  whiteList['page'] = false; // default: auto
  whiteList['page-break-after'] = false; // default: auto
  whiteList['page-break-before'] = false; // default: auto
  whiteList['page-break-inside'] = false; // default: auto
  whiteList['page-policy'] = false; // default: start
  whiteList['pause'] = false; // default: implementation dependent
  whiteList['pause-after'] = false; // default: implementation dependent
  whiteList['pause-before'] = false; // default: implementation dependent
  whiteList['perspective'] = false; // default: none
  whiteList['perspective-origin'] = false; // default: 50% 50%
  whiteList['pitch'] = false; // default: medium
  whiteList['pitch-range'] = false; // default: 50
  whiteList['play-during'] = false; // default: auto
  whiteList['position'] = false; // default: static
  whiteList['presentation-level'] = false; // default: 0
  whiteList['quotes'] = false; // default: text
  whiteList['region-fragment'] = false; // default: auto
  whiteList['resize'] = false; // default: none
  whiteList['rest'] = false; // default: depending on individual properties
  whiteList['rest-after'] = false; // default: none
  whiteList['rest-before'] = false; // default: none
  whiteList['richness'] = false; // default: 50
  whiteList['right'] = false; // default: auto
  whiteList['rotation'] = false; // default: 0
  whiteList['rotation-point'] = false; // default: 50% 50%
  whiteList['ruby-align'] = false; // default: auto
  whiteList['ruby-merge'] = false; // default: separate
  whiteList['ruby-position'] = false; // default: before
  whiteList['shape-image-threshold'] = false; // default: 0.0
  whiteList['shape-outside'] = false; // default: none
  whiteList['shape-margin'] = false; // default: 0
  whiteList['size'] = false; // default: auto
  whiteList['speak'] = false; // default: auto
  whiteList['speak-as'] = false; // default: normal
  whiteList['speak-header'] = false; // default: once
  whiteList['speak-numeral'] = false; // default: continuous
  whiteList['speak-punctuation'] = false; // default: none
  whiteList['speech-rate'] = false; // default: medium
  whiteList['stress'] = false; // default: 50
  whiteList['string-set'] = false; // default: none
  whiteList['tab-size'] = false; // default: 8
  whiteList['table-layout'] = false; // default: auto
  whiteList['text-align'] = true; // default: start
  whiteList['text-align-last'] = true; // default: auto
  whiteList['text-combine-upright'] = true; // default: none
  whiteList['text-decoration'] = true; // default: none
  whiteList['text-decoration-color'] = true; // default: currentColor
  whiteList['text-decoration-line'] = true; // default: none
  whiteList['text-decoration-skip'] = true; // default: objects
  whiteList['text-decoration-style'] = true; // default: solid
  whiteList['text-emphasis'] = true; // default: depending on individual properties
  whiteList['text-emphasis-color'] = true; // default: currentColor
  whiteList['text-emphasis-position'] = true; // default: over right
  whiteList['text-emphasis-style'] = true; // default: none
  whiteList['text-height'] = true; // default: auto
  whiteList['text-indent'] = true; // default: 0
  whiteList['text-justify'] = true; // default: auto
  whiteList['text-orientation'] = true; // default: mixed
  whiteList['text-overflow'] = true; // default: clip
  whiteList['text-shadow'] = true; // default: none
  whiteList['text-space-collapse'] = true; // default: collapse
  whiteList['text-transform'] = true; // default: none
  whiteList['text-underline-position'] = true; // default: auto
  whiteList['text-wrap'] = true; // default: normal
  whiteList['top'] = false; // default: auto
  whiteList['transform'] = false; // default: none
  whiteList['transform-origin'] = false; // default: 50% 50% 0
  whiteList['transform-style'] = false; // default: flat
  whiteList['transition'] = false; // default: depending on individual properties
  whiteList['transition-delay'] = false; // default: 0s
  whiteList['transition-duration'] = false; // default: 0s
  whiteList['transition-property'] = false; // default: all
  whiteList['transition-timing-function'] = false; // default: ease
  whiteList['unicode-bidi'] = false; // default: normal
  whiteList['vertical-align'] = false; // default: baseline
  whiteList['visibility'] = false; // default: visible
  whiteList['voice-balance'] = false; // default: center
  whiteList['voice-duration'] = false; // default: auto
  whiteList['voice-family'] = false; // default: implementation dependent
  whiteList['voice-pitch'] = false; // default: medium
  whiteList['voice-range'] = false; // default: medium
  whiteList['voice-rate'] = false; // default: normal
  whiteList['voice-stress'] = false; // default: normal
  whiteList['voice-volume'] = false; // default: medium
  whiteList['volume'] = false; // default: medium
  whiteList['white-space'] = false; // default: normal
  whiteList['widows'] = false; // default: 2
  whiteList['width'] = true; // default: auto
  whiteList['will-change'] = false; // default: auto
  whiteList['word-break'] = true; // default: normal
  whiteList['word-spacing'] = true; // default: normal
  whiteList['word-wrap'] = true; // default: normal
  whiteList['wrap-flow'] = false; // default: auto
  whiteList['wrap-through'] = false; // default: wrap
  whiteList['writing-mode'] = false; // default: horizontal-tb
  whiteList['z-index'] = false; // default: auto

  return whiteList;
}


/**
 * 匹配到白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onAttr (name, value, options) {
  // do nothing
}

/**
 * 匹配到不在白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onIgnoreAttr (name, value, options) {
  // do nothing
}

var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;

/**
 * 过滤属性值
 *
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function safeAttrValue(name, value) {
  if (REGEXP_URL_JAVASCRIPT.test(value)) return '';
  return value;
}


exports.whiteList = getDefaultWhiteList();
exports.getDefaultWhiteList = getDefaultWhiteList;
exports.onAttr = onAttr;
exports.onIgnoreAttr = onIgnoreAttr;
exports.safeAttrValue = safeAttrValue;


/***/ }),

/***/ "0Zbq":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("/cOS");
var FilterCSS = __webpack_require__("huvo");


/**
 * XSS过滤
 *
 * @param {String} css 要过滤的CSS代码
 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
 * @return {String}
 */
function filterCSS (html, options) {
  var xss = new FilterCSS(options);
  return xss.process(html);
}


// 输出
exports = module.exports = filterCSS;
exports.FilterCSS = FilterCSS;
for (var i in DEFAULT) exports[i] = DEFAULT[i];

// 在浏览器端使用
if (typeof window !== 'undefined') {
  window.filterCSS = module.exports;
}


/***/ }),

/***/ "1fVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3XGG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bdlu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E4I8":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_E4I8__;

/***/ }),

/***/ "FVwl":
/***/ (function(module, exports, __webpack_require__) {

/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS = __webpack_require__("0Zbq").FilterCSS;
var DEFAULT = __webpack_require__("oz9r");
var parser = __webpack_require__("krhF");
var parseTag = parser.parseTag;
var parseAttr = parser.parseAttr;
var _ = __webpack_require__("noAI");

/**
 * returns `true` if the input value is `undefined` or `null`
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull(obj) {
  return obj === undefined || obj === null;
}

/**
 * get attributes for a tag
 *
 * @param {String} html
 * @return {Object}
 *   - {String} html
 *   - {Boolean} closing
 */
function getAttrs(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    return {
      html: "",
      closing: html[html.length - 2] === "/"
    };
  }
  html = _.trim(html.slice(i + 1, -1));
  var isClosing = html[html.length - 1] === "/";
  if (isClosing) html = _.trim(html.slice(0, -1));
  return {
    html: html,
    closing: isClosing
  };
}

/**
 * shallow copy
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject(obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * FilterXSS class
 *
 * @param {Object} options
 *        whiteList, onTag, onTagAttr, onIgnoreTag,
 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
 */
function FilterXSS(options) {
  options = shallowCopyObject(options || {});

  if (options.stripIgnoreTag) {
    if (options.onIgnoreTag) {
      console.error(
        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
      );
    }
    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
  }

  options.whiteList = options.whiteList || DEFAULT.whiteList;
  options.onTag = options.onTag || DEFAULT.onTag;
  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
  this.options = options;

  if (options.css === false) {
    this.cssFilter = false;
  } else {
    options.css = options.css || {};
    this.cssFilter = new FilterCSS(options.css);
  }
}

/**
 * start process and returns result
 *
 * @param {String} html
 * @return {String}
 */
FilterXSS.prototype.process = function(html) {
  // compatible with the input
  html = html || "";
  html = html.toString();
  if (!html) return "";

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onTag = options.onTag;
  var onIgnoreTag = options.onIgnoreTag;
  var onTagAttr = options.onTagAttr;
  var onIgnoreTagAttr = options.onIgnoreTagAttr;
  var safeAttrValue = options.safeAttrValue;
  var escapeHtml = options.escapeHtml;
  var cssFilter = me.cssFilter;

  // remove invisible characters
  if (options.stripBlankChar) {
    html = DEFAULT.stripBlankChar(html);
  }

  // remove html comments
  if (!options.allowCommentTag) {
    html = DEFAULT.stripCommentTag(html);
  }

  // if enable stripIgnoreTagBody
  var stripIgnoreTagBody = false;
  if (options.stripIgnoreTagBody) {
    var stripIgnoreTagBody = DEFAULT.StripTagBody(
      options.stripIgnoreTagBody,
      onIgnoreTag
    );
    onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
  }

  var retHtml = parseTag(
    html,
    function(sourcePosition, position, tag, html, isClosing) {
      var info = {
        sourcePosition: sourcePosition,
        position: position,
        isClosing: isClosing,
        isWhite: whiteList.hasOwnProperty(tag)
      };

      // call `onTag()`
      var ret = onTag(tag, html, info);
      if (!isNull(ret)) return ret;

      if (info.isWhite) {
        if (info.isClosing) {
          return "</" + tag + ">";
        }

        var attrs = getAttrs(html);
        var whiteAttrList = whiteList[tag];
        var attrsHtml = parseAttr(attrs.html, function(name, value) {
          // call `onTagAttr()`
          var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
          var ret = onTagAttr(tag, name, value, isWhiteAttr);
          if (!isNull(ret)) return ret;

          if (isWhiteAttr) {
            // call `safeAttrValue()`
            value = safeAttrValue(tag, name, value, cssFilter);
            if (value) {
              return name + '="' + value + '"';
            } else {
              return name;
            }
          } else {
            // call `onIgnoreTagAttr()`
            var ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
            if (!isNull(ret)) return ret;
            return;
          }
        });

        // build new tag html
        var html = "<" + tag;
        if (attrsHtml) html += " " + attrsHtml;
        if (attrs.closing) html += " /";
        html += ">";
        return html;
      } else {
        // call `onIgnoreTag()`
        var ret = onIgnoreTag(tag, html, info);
        if (!isNull(ret)) return ret;
        return escapeHtml(html);
      }
    },
    escapeHtml
  );

  // if enable stripIgnoreTagBody
  if (stripIgnoreTagBody) {
    retHtml = stripIgnoreTagBody.remove(retHtml);
  }

  return retHtml;
};

module.exports = FilterXSS;


/***/ }),

/***/ "I3Iz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I9N9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmof":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;

/***/ }),

/***/ "KSGD":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("Q4WQ")();
}


/***/ }),

/***/ "NG4M":
/***/ (function(module, exports, __webpack_require__) {

/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("oz9r");
var parser = __webpack_require__("krhF");
var FilterXSS = __webpack_require__("FVwl");

/**
 * filter xss function
 *
 * @param {String} html
 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
 * @return {String}
 */
function filterXSS(html, options) {
  var xss = new FilterXSS(options);
  return xss.process(html);
}

exports = module.exports = filterXSS;
exports.FilterXSS = FilterXSS;
for (var i in DEFAULT) exports[i] = DEFAULT[i];
for (var i in parser) exports[i] = parser[i];

// using `xss` on the browser, output `filterXSS` to the globals
if (typeof window !== "undefined") {
  window.filterXSS = module.exports;
}


/***/ }),

/***/ "Q4WQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("e6+Q");
var invariant = __webpack_require__("cxPT");
var ReactPropTypesSecret = __webpack_require__("gt/O");

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "R5aA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RIUQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uo+f":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var _ = __webpack_require__("jCb9");


/**
 * 解析style
 *
 * @param {String} css
 * @param {Function} onAttr 处理属性的函数
 *   参数格式： function (sourcePosition, position, name, value, source)
 * @return {String}
 */
function parseStyle (css, onAttr) {
  css = _.trimRight(css);
  if (css[css.length - 1] !== ';') css += ';';
  var cssLength = css.length;
  var isParenthesisOpen = false;
  var lastPos = 0;
  var i = 0;
  var retCSS = '';

  function addNewAttr () {
    // 如果没有正常的闭合圆括号，则直接忽略当前属性
    if (!isParenthesisOpen) {
      var source = _.trim(css.slice(lastPos, i));
      var j = source.indexOf(':');
      if (j !== -1) {
        var name = _.trim(source.slice(0, j));
        var value = _.trim(source.slice(j + 1));
        // 必须有属性名称
        if (name) {
          var ret = onAttr(lastPos, retCSS.length, name, value, source);
          if (ret) retCSS += ret + '; ';
        }
      }
    }
    lastPos = i + 1;
  }

  for (; i < cssLength; i++) {
    var c = css[i];
    if (c === '/' && css[i + 1] === '*') {
      // 备注开始
      var j = css.indexOf('*/', i + 2);
      // 如果没有正常的备注结束，则后面的部分全部跳过
      if (j === -1) break;
      // 直接将当前位置调到备注结尾，并且初始化状态
      i = j + 1;
      lastPos = i + 1;
      isParenthesisOpen = false;
    } else if (c === '(') {
      isParenthesisOpen = true;
    } else if (c === ')') {
      isParenthesisOpen = false;
    } else if (c === ';') {
      if (isParenthesisOpen) {
        // 在圆括号里面，忽略
      } else {
        addNewAttr();
      }
    } else if (c === '\n') {
      addNewAttr();
    }
  }

  return _.trim(retCSS);
}

module.exports = parseStyle;


/***/ }),

/***/ "cxPT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "e6+Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"seller_card":{"badge_now":"NOW","contact_me":"Contact Me","custom_order":"Custom Order","member_since":"Member since","from":"From","num_reviews":{"one":"%{count} review","other":"%{count} reviews"},"oneliner":{"placeholder":"What's your story in one line?","error_oneliner_short":"Text is too short - must be at least 3 characters.","error_oneliner_long":"Text is too long - must be 70 characters or less.","error_oneliner_invalid":"Text must contain only letters, numbers and (,!:')."},"read_more_text":{"more":"+ See More","less":"- See Less"},"recent_delivery":"Recent Delivery","response_time":"Avg. Response Time","response_time_hours":{"one":"1 hour","other":"${count} hours"},"response_time_days":{"one":"1 day","other":"${count} days"},"out_of_office":"Out of Office","pro":{"tooltip_seller":"Pro sellers are pre-vetted and hand selected professionals, verified by Fiverr","verified_by":"Verified by Fiverr in"},"view_as_buyer":"Preview Public Mode","view_as_seller":"Edit Profile Mode"}}

/***/ }),

/***/ "gt/O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "huvo":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("/cOS");
var parseStyle = __webpack_require__("Uo+f");
var _ = __webpack_require__("jCb9");


/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull (obj) {
  return (obj === undefined || obj === null);
}

/**
 * 浅拷贝对象
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject (obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * 创建CSS过滤器
 *
 * @param {Object} options
 *   - {Object} whiteList
 *   - {Function} onAttr
 *   - {Function} onIgnoreAttr
 *   - {Function} safeAttrValue
 */
function FilterCSS (options) {
  options = shallowCopyObject(options || {});
  options.whiteList = options.whiteList || DEFAULT.whiteList;
  options.onAttr = options.onAttr || DEFAULT.onAttr;
  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT.onIgnoreAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  this.options = options;
}

FilterCSS.prototype.process = function (css) {
  // 兼容各种奇葩输入
  css = css || '';
  css = css.toString();
  if (!css) return '';

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onAttr = options.onAttr;
  var onIgnoreAttr = options.onIgnoreAttr;
  var safeAttrValue = options.safeAttrValue;

  var retCSS = parseStyle(css, function (sourcePosition, position, name, value, source) {

    var check = whiteList[name];
    var isWhite = false;
    if (check === true) isWhite = check;
    else if (typeof check === 'function') isWhite = check(value);
    else if (check instanceof RegExp) isWhite = check.test(value);
    if (isWhite !== true) isWhite = false;

    // 如果过滤后 value 为空则直接忽略
    value = safeAttrValue(name, value);
    if (!value) return;

    var opts = {
      position: position,
      sourcePosition: sourcePosition,
      source: source,
      isWhite: isWhite
    };

    if (isWhite) {

      var ret = onAttr(name, value, opts);
      if (isNull(ret)) {
        return name + ':' + value;
      } else {
        return ret;
      }

    } else {

      var ret = onIgnoreAttr(name, value, opts);
      if (!isNull(ret)) {
        return ret;
      }

    }
  });

  return retCSS;
};


module.exports = FilterCSS;


/***/ }),

/***/ "iCOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "itU2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jCb9":
/***/ (function(module, exports) {

module.exports = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, '');
  },
  trimRight: function (str) {
    if (String.prototype.trimRight) {
      return str.trimRight();
    }
    return str.replace(/(\s*$)/g, '');
  }
};


/***/ }),

/***/ "krhF":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var _ = __webpack_require__("noAI");

/**
 * get tag name
 *
 * @param {String} html e.g. '<a hef="#">'
 * @return {String}
 */
function getTagName(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    var tagName = html.slice(1, -1);
  } else {
    var tagName = html.slice(1, i + 1);
  }
  tagName = _.trim(tagName).toLowerCase();
  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
  return tagName;
}

/**
 * is close tag?
 *
 * @param {String} html 如：'<a hef="#">'
 * @return {Boolean}
 */
function isClosing(html) {
  return html.slice(0, 2) === "</";
}

/**
 * parse input html and returns processed html
 *
 * @param {String} html
 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
 * @param {Function} escapeHtml
 * @return {String}
 */
function parseTag(html, onTag, escapeHtml) {
  "user strict";

  var rethtml = "";
  var lastPos = 0;
  var tagStart = false;
  var quoteStart = false;
  var currentPos = 0;
  var len = html.length;
  var currentTagName = "";
  var currentHtml = "";

  for (currentPos = 0; currentPos < len; currentPos++) {
    var c = html.charAt(currentPos);
    if (tagStart === false) {
      if (c === "<") {
        tagStart = currentPos;
        continue;
      }
    } else {
      if (quoteStart === false) {
        if (c === "<") {
          rethtml += escapeHtml(html.slice(lastPos, currentPos));
          tagStart = currentPos;
          lastPos = currentPos;
          continue;
        }
        if (c === ">") {
          rethtml += escapeHtml(html.slice(lastPos, tagStart));
          currentHtml = html.slice(tagStart, currentPos + 1);
          currentTagName = getTagName(currentHtml);
          rethtml += onTag(
            tagStart,
            rethtml.length,
            currentTagName,
            currentHtml,
            isClosing(currentHtml)
          );
          lastPos = currentPos + 1;
          tagStart = false;
          continue;
        }
        if ((c === '"' || c === "'") && html.charAt(currentPos - 1) === "=") {
          quoteStart = c;
          continue;
        }
      } else {
        if (c === quoteStart) {
          quoteStart = false;
          continue;
        }
      }
    }
  }
  if (lastPos < html.length) {
    rethtml += escapeHtml(html.substr(lastPos));
  }

  return rethtml;
}

var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9_:\.\-]/gim;

/**
 * parse input attributes and returns processed attributes
 *
 * @param {String} html e.g. `href="#" target="_blank"`
 * @param {Function} onAttr e.g. `function (name, value)`
 * @return {String}
 */
function parseAttr(html, onAttr) {
  "user strict";

  var lastPos = 0;
  var retAttrs = [];
  var tmpName = false;
  var len = html.length;

  function addAttr(name, value) {
    name = _.trim(name);
    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
    if (name.length < 1) return;
    var ret = onAttr(name, value || "");
    if (ret) retAttrs.push(ret);
  }

  // 逐个分析字符
  for (var i = 0; i < len; i++) {
    var c = html.charAt(i);
    var v, j;
    if (tmpName === false && c === "=") {
      tmpName = html.slice(lastPos, i);
      lastPos = i + 1;
      continue;
    }
    if (tmpName !== false) {
      if (
        i === lastPos &&
        (c === '"' || c === "'") &&
        html.charAt(i - 1) === "="
      ) {
        j = html.indexOf(c, i + 1);
        if (j === -1) {
          break;
        } else {
          v = _.trim(html.slice(lastPos + 1, j));
          addAttr(tmpName, v);
          tmpName = false;
          i = j;
          lastPos = i + 1;
          continue;
        }
      }
    }
    if (/\s|\n|\t/.test(c)) {
      html = html.replace(/\s|\n|\t/g, " ");
      if (tmpName === false) {
        j = findNextEqual(html, i);
        if (j === -1) {
          v = _.trim(html.slice(lastPos, i));
          addAttr(v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          i = j - 1;
          continue;
        }
      } else {
        j = findBeforeEqual(html, i - 1);
        if (j === -1) {
          v = _.trim(html.slice(lastPos, i));
          v = stripQuoteWrap(v);
          addAttr(tmpName, v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          continue;
        }
      }
    }
  }

  if (lastPos < html.length) {
    if (tmpName === false) {
      addAttr(html.slice(lastPos));
    } else {
      addAttr(tmpName, stripQuoteWrap(_.trim(html.slice(lastPos))));
    }
  }

  return _.trim(retAttrs.join(" "));
}

function findNextEqual(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function findBeforeEqual(str, i) {
  for (; i > 0; i--) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function isQuoteWrapString(text) {
  if (
    (text[0] === '"' && text[text.length - 1] === '"') ||
    (text[0] === "'" && text[text.length - 1] === "'")
  ) {
    return true;
  } else {
    return false;
  }
}

function stripQuoteWrap(text) {
  if (isQuoteWrapString(text)) {
    return text.substr(1, text.length - 2);
  } else {
    return text;
  }
}

exports.parseTag = parseTag;
exports.parseAttr = parseAttr;


/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"}
var external___commonjs___react___commonjs2___react___amd___react___root___React__ = __webpack_require__("Jmof");
var external___commonjs___react___commonjs2___react___amd___react___root___React___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react___commonjs2___react___amd___react___root___React__);

// EXTERNAL MODULE: external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM"}
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM__ = __webpack_require__("wLXD");
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM__);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./src/components/status/style.scss
var style = __webpack_require__("I9N9");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/components/status/index.js




/**
 * @function
 * @name Status
 * @param {Boolean} isOnline - whether the user is online
 * @param {Integer} userId - the user's id
 * @param {Boolean} isOnVacation - whether the user is out of office
 * Returns the markup of the online indicator
 */

var status_Status = function Status(_ref) {
    var isOnline = _ref.isOnline,
        userId = _ref.userId,
        isOnVacation = _ref.isOnVacation;

    if (!isOnVacation) {
        return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'span',
            { className: 'user-online-indicator ' + (isOnline ? 'is-online ' : ''), 'data-user-id': userId },
            external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('i', { className: 'fa fa-circle' }),
            i18n.t('general.online')
        );
    }

    return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
        'span',
        { className: 'user-ooo-indicator', 'data-user-id': userId },
        i18n.t('seller_card.out_of_office')
    );
};

status_Status.propTypes = {
    isOnVacation: prop_types_default.a.bool.isRequired,
    isOnline: prop_types_default.a.bool,
    userId: prop_types_default.a.number
};

/* harmony default export */ var components_status = (status_Status);
// EXTERNAL MODULE: ./src/components/badges/style.scss
var badges_style = __webpack_require__("itU2");
var badges_style_default = /*#__PURE__*/__webpack_require__.n(badges_style);

// CONCATENATED MODULE: ./src/components/badges/index.js




/**
 * @function
 * @name Badges
 * @param {String} userName - the user's name
 * @param {Boolean} showAmbassador - should show the ambassador badge
 * @param {Boolean} showNow - should show the now badge
 * Returns the markup of the seller card badges
 */

var badges_Badges = function Badges(_ref) {
    var userName = _ref.userName,
        showAmbassador = _ref.showAmbassador,
        showNow = _ref.showNow;


    // now & ambassador badges take up the same space, so the now badge
    // takes precedence

    if (showNow) {

        return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'aside',
            { className: 'now-badge' },
            i18n.t('seller_card.badge_now'),
            ' ',
            external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'span',
                { className: 'beta-badge' },
                i18n.t('general.beta')
            )
        );
    } else if (showAmbassador) {

        return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'a',
            { href: 'https://www.fiverr.com/ambassadors/' + userName, className: 'ambassadors-badge' },
            i18n.t('general.ambassador')
        );
    }
};

badges_Badges.propTypes = {
    userName: prop_types_default.a.string,
    showAmbassador: prop_types_default.a.bool.isRequired,
    showNow: prop_types_default.a.bool.isRequired
};

/* harmony default export */ var badges = (badges_Badges);
// EXTERNAL MODULE: ./src/components/profile_image/style.scss
var profile_image_style = __webpack_require__("sfau");
var profile_image_style_default = /*#__PURE__*/__webpack_require__.n(profile_image_style);

// CONCATENATED MODULE: ./src/components/profile_image/index.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * @class
 * @name ProfileImage
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {String} authToken - Fiverr authentication token
 * Returns the markup of the user profile image
 */

var profile_image_ProfileImage = function (_Component) {
    _inherits(ProfileImage, _Component);

    function ProfileImage(props) {
        _classCallCheck(this, ProfileImage);

        var _this = _possibleConstructorReturn(this, (ProfileImage.__proto__ || Object.getPrototypeOf(ProfileImage)).call(this, props));

        _this.state = {
            file: null,
            saving: false,
            newImage: ''
        };

        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.displayImage = _this.displayImage.bind(_this);
        return _this;
    }

    _createClass(ProfileImage, [{
        key: 'onInputChange',
        value: function onInputChange(e) {
            var _this2 = this;

            var file = e.target.files[0];

            if (!file) {
                return;
            }

            this.setState({
                file: file,
                saving: true
            }, function () {
                _this2.directUploadFile();
            });
        }
    }, {
        key: 'displayImage',
        value: function displayImage(fileUrl) {

            this.setState({
                file: null,
                saving: false,
                newImage: fileUrl
            });
        }
    }, {
        key: 'directUploadFile',
        value: function directUploadFile() {
            var _this3 = this;

            var startTime = Date.now(),
                file = this.state.file;

            gofor('/attachments/policy', {
                method: 'POST',
                body: JSON.stringify({ 'object_name': 'profile', 'attachment_name': 'photo' })
            }).then(function (response) {
                return response.json();
            }).then(function (data) {

                Fiverr._broadcastLogEvents({
                    facility: 'graphite',
                    type: 'timing',
                    label: 'profile.filerr.seller_page.s3_policy',
                    value: Date.now() - startTime
                });

                var policy = data.policy.fiverr_policy;

                if (policy.supported_file_types.indexOf(file.type) === -1) {

                    // unsupported file
                    Fiverr._logEventToGraphite({
                        label: 'profile.filerr.seller_page.ajax.unsupported_file.' + file.name.split('.').pop(),
                        percentage: 100
                    });

                    _this3.setState({
                        file: null,
                        saving: false,
                        newImage: ''
                    });
                } else {
                    _this3.uploadFileToS3(data);
                }
            }).catch(function (err) {
                throw err;
            });
        }
    }, {
        key: 'uploadFileToS3',
        value: function uploadFileToS3(policyResponse) {
            var _this4 = this;

            var s3Policy = policyResponse.policy.s3_policy,
                clientUniqId = Math.floor(Math.random() * 26) + Date.now(),
                clientGuid = s3Policy.guid + s3Policy.client_uniq_id_prefix + clientUniqId,
                key = s3Policy.key.replace(s3Policy.guid, clientGuid),
                s3StartTime = Date.now(),
                formData = new FormData(),
                file = this.state.file;

            formData.append('acl', s3Policy.acl);
            formData.append('AWSAccessKeyId', s3Policy.AWSAccessKeyId);
            formData.append('success_action_status', s3Policy.success_action_status);
            formData.append('key', key);
            formData.append('policy', s3Policy.policy);
            formData.append('signature', s3Policy.signature);
            formData.append('content-type', file.type);
            formData.append('file', file);

            fetch(s3Policy.action_url, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.text();
            }).then(function (data) {

                Fiverr._broadcastLogEvents({
                    facility: 'graphite',
                    type: 'timing',
                    label: 'profile.filerr.seller_page.s3_direct_upload',
                    value: Date.now() - s3StartTime
                });

                // the response is html, so needs to be converted to a fragment before
                // we can do anything with it
                var frag = document.createRange().createContextualFragment(data),
                    fragKey = frag.querySelector('Key').firstChild.nodeValue,
                    fragBucket = frag.querySelector('Bucket').firstChild.nodeValue;

                // after the file has uploaded successfully, we will create a pending attachment and
                // link it to the user profile

                var formDataTemp = new FormData();
                formDataTemp.append('authenticity_token', _this4.props.authToken);
                formDataTemp.append('s3_file_path', fragKey);
                formDataTemp.append('bucket_name', fragBucket);

                return fetch('/profiles/update_photo', {
                    method: 'POST',
                    body: formDataTemp,
                    headers: new Headers({
                        'Accept': 'application/json',
                        'X-CSRF-Token': _this4.props.authToken
                    }),
                    credentials: 'same-origin'
                });
            }).then(function (response) {
                return response.json();
            }).then(function (data) {

                Fiverr._broadcastLogEvents({
                    facility: 'graphite',
                    type: 'timing',
                    label: 'profile.filerr.seller_page.update_photo',
                    value: Date.now() - s3StartTime
                });

                _this4.displayImage(data.url);
            }).catch(function (err) {

                Fiverr._logEventToGraphite({
                    label: 'profile.filerr.seller_page.ajax.s3_upload.error',
                    percentage: 100
                });

                Fiverr._logErrorToServer('seller_card_package', 'Seller Filerr photo', '[s3_direct_upload] ' + err.responseText + ', status:' + err.status);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                allowEditing = _props.allowEditing;


            var showUserBadge = user.is_seller && user.achievement && user.achievement > 0,
                badgeClasses = [{ rating: 0, class: 'no_level_seller' }, { rating: 1, class: 'level_one_seller' }, { rating: 2, class: 'level_two_seller' }, { rating: 5, class: 'top_rated_seller' }],
                badgeClass = showUserBadge ? badgeClasses.find(function (b) {
                return b.rating === user.achievement;
            }).class : '',
                newImage = this.state.newImage,
                hasImage = user.has_profile_photo || newImage,
                userNameLetter = user.username ? user.username.substring(0, 1) : 'x';

            var userImage = void 0,
                labelClass = '';

            if (allowEditing && !this.state.saving) {
                labelClass = 'editable';
            } else if (this.state.saving) {
                labelClass = 'loading';
            }

            if (hasImage) {
                userImage = external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('img', { src: newImage ? newImage : user.profile_photo, className: 'user-pict-img', alt: user.username, width: '150', height: '150' });
            } else {
                userImage = external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'span',
                    { className: 'missing-image-user' },
                    userNameLetter
                );
            }

            return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'label',
                { className: 'user-pict-150 ' + labelClass, htmlFor: 'profile_image' },
                allowEditing && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('input', { accept: 'image/png,image/jpeg', className: 'hidden', onChange: this.onInputChange, id: 'profile_image', name: 'profile[image]', type: 'file' }),
                userImage,
                showUserBadge && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('a', { href: '/levels', className: 'user-badge-round-med ' + badgeClass })
            );
        }
    }]);

    return ProfileImage;
}(external___commonjs___react___commonjs2___react___amd___react___root___React__["Component"]);

profile_image_ProfileImage.propTypes = {
    user: prop_types_default.a.object.isRequired,
    allowEditing: prop_types_default.a.bool.isRequired,
    authToken: prop_types_default.a.string.isRequired
};

/* harmony default export */ var profile_image = (profile_image_ProfileImage);
// EXTERNAL MODULE: ./src/components/profile_link/style.scss
var profile_link_style = __webpack_require__("I3Iz");
var profile_link_style_default = /*#__PURE__*/__webpack_require__.n(profile_link_style);

// CONCATENATED MODULE: ./src/components/profile_link/index.js




var profile_link_RenderName = function RenderName(_ref) {
    var userName = _ref.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
        'b',
        { className: 'seller-link' },
        userName
    );
};

var profile_link_RenderNameWithLink = function RenderNameWithLink(_ref2) {
    var userName = _ref2.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
        'a',
        { href: '/' + userName, className: 'seller-link', rel: 'nofollow,noindex' },
        userName
    );
};

/**
 * @function
 * @name ProfileLink
 * @param {String} userName - the user's name
 * @param {Boolean} noLink - text only, don't make it a link
 * Returns the markup of the user profile link
 */

var profile_link_ProfileLink = function ProfileLink(_ref3) {
    var userName = _ref3.userName,
        noLink = _ref3.noLink;
    return noLink ? external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(profile_link_RenderName, { userName: userName }) : external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(profile_link_RenderNameWithLink, { userName: userName });
};

profile_link_ProfileLink.propTypes = {
    userName: prop_types_default.a.string,
    noLink: prop_types_default.a.bool
};

/* harmony default export */ var profile_link = (profile_link_ProfileLink);
// CONCATENATED MODULE: ./src/utils.js
/**
 * @name hasOneliner
 * @param {String} oneLiner - seller's oneliner text
 * @return {Boolean} Does this seller have a valid oneliner text?
 */
function hasOneliner(oneLiner) {
    return oneLiner && oneLiner.length > 0 && oneLiner !== i18n.t('seller_card.oneliner.placeholder');
}

/**
 * @name showResponseTime
 * @param {String} sellerResponsiveness - seller's responsive time
 * @return {Boolean} Does this seller have a valid responsive time?
 */
function showResponseTime(sellerResponsiveness) {
    return parseInt(sellerResponsiveness, 10) > 0;
}

/**
 * @name formatHoursAsDays
 * @param {Integer} hours - the hours that should be formatted
 * @return {String} A translated string with either hours or days
 */
function formatHoursAsDays(hours) {

    var output = void 0;

    if (hours < 24) {
        output = i18n.t('seller_card.response_time_hours', { count: hours });
    } else {
        var days = Math.round(hours / 24);
        output = i18n.t('seller_card.response_time_days', { count: days });
    }

    return output;
}

/**
 * Replace break tags with something else
 * @param  {String} string
 * @param  {String} [replacer='\r\n']
 * @return {String}
 */
var replaceBreakTags = function replaceBreakTags(string) {
    var replacer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\r\n';
    return string.replace(/\s?(<br\s?\/?>)\s?/g, replacer);
}; // eslint-disable-line no-control-regex
// EXTERNAL MODULE: ./src/components/oneliner/style.scss
var oneliner_style = __webpack_require__("1fVw");
var oneliner_style_default = /*#__PURE__*/__webpack_require__.n(oneliner_style);

// CONCATENATED MODULE: ./src/components/oneliner/index.js
var oneliner__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function oneliner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function oneliner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function oneliner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * @class
 * @name Oneliner
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {String} authToken - Fiverr authentication token
 * Returns the markup of the user oneliner & ratings
 */

var oneliner_Oneliner = function (_Component) {
    oneliner__inherits(Oneliner, _Component);

    function Oneliner(props) {
        oneliner__classCallCheck(this, Oneliner);

        var _this = oneliner__possibleConstructorReturn(this, (Oneliner.__proto__ || Object.getPrototypeOf(Oneliner)).call(this, props));

        _this.state = {
            mode: 'view', // view, edit, error
            oneliner: '',
            initialOneliner: '',
            errorText: ''
        };

        _this.onEditIconClick = _this.onEditIconClick.bind(_this);
        _this.onSaveClick = _this.onSaveClick.bind(_this);
        _this.onCancelClick = _this.onCancelClick.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onInputKeyPress = _this.onInputKeyPress.bind(_this);
        return _this;
    }

    oneliner__createClass(Oneliner, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var onelinerText = '';

            if (hasOneliner(this.props.user.one_liner)) {
                onelinerText = this.props.user.one_liner;
            } else if (this.props.allowEditing) {
                onelinerText = i18n.t('seller_card.oneliner.placeholder');
            }

            this.setState({
                oneliner: onelinerText,
                initialOneliner: onelinerText
            });
        }
    }, {
        key: 'onEditIconClick',
        value: function onEditIconClick() {
            this.setState({
                mode: 'edit'
            });
        }
    }, {
        key: 'onSaveClick',
        value: function onSaveClick(e) {
            e.preventDefault();

            var check = this.checkForValid();
            if (check.isValid) {

                if (typeof fetch !== 'undefined' && this.state.oneliner !== this.state.initialOneliner) {

                    fetch('/users/' + this.props.user.username, {
                        method: 'PATCH',
                        body: encodeURI('user[profile_attributes][one_liner]=' + this.state.oneliner),
                        headers: new Headers({
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-CSRF-Token': this.props.authToken
                        }),
                        credentials: 'same-origin'
                    }).catch(function (err) {
                        console.log('There was an error when trying to update the oneliner: ', err.message); // eslint-disable-line
                    });
                }

                this.setState({
                    mode: 'view',
                    initialOneliner: this.state.oneliner,
                    errorText: ''
                });
            } else {

                this.setState({
                    mode: 'error',
                    errorText: check.errorText
                });
            }
        }
    }, {
        key: 'onCancelClick',
        value: function onCancelClick(e) {
            e.preventDefault();
            this.setState({
                mode: 'view',
                oneliner: this.state.initialOneliner,
                errorText: ''
            });
        }
    }, {
        key: 'onInputChange',
        value: function onInputChange(e) {
            this.setState({
                oneliner: e.target.value,
                errorText: ''
            });
        }
    }, {
        key: 'onInputKeyPress',
        value: function onInputKeyPress(e) {
            if (e.key === 'Enter') {
                this.onSaveClick(e);
            }
        }
    }, {
        key: 'checkForValid',
        value: function checkForValid() {

            var value = this.state.oneliner;

            var isValid = true,
                errorText = '';

            // validate oneliner
            if (value === '' || value.length < 3) {
                // blank text, text too short
                isValid = false;
                errorText = i18n.t('seller_card.oneliner.error_oneliner_short');
            } else if (value.length > 70) {
                // text too long
                isValid = false;
                errorText = i18n.t('seller_card.oneliner.error_oneliner_long');
            } else if (value === this.state.initialOneliner) {
                // text hasn't changed, do nothing
            } else if (value.trim() === i18n.t('seller_card.oneliner.placeholder')) {
                // text is the default placeholder, do nothing
            } else {
                if (/^[a-zA-Z0-9\s\,\?\:\'\"\!]+$/.test(value)) {// eslint-disable-line
                    // text has changed & is valid
                } else {
                    // text has changed, but is invalid
                    isValid = false;
                    errorText = i18n.t('seller_card.oneliner.error_oneliner_invalid');
                }
            }

            return {
                isValid: isValid,
                errorText: errorText
            };
        }
    }, {
        key: 'renderEditIcon',
        value: function renderEditIcon() {
            return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('i', { className: 'fa fa-pencil icn-edit', onClick: this.onEditIconClick });
        }
    }, {
        key: 'renderEditForm',
        value: function renderEditForm() {
            var _this2 = this;

            var showError = this.state.mode === 'error' && this.state.errorText !== '';

            return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'form',
                null,
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('input', { type: 'text', name: 'user[profile_attributes][one_liner]', autoFocus: 'autofocus', maxLength: '70', ref: function ref(inp) {
                        return inp && inp.focus();
                    }, value: this.state.oneliner, autoComplete: 'off', onChange: function onChange(e) {
                        return _this2.onInputChange(e);
                    }, onKeyPress: function onKeyPress(e) {
                        return _this2.onInputKeyPress(e);
                    } }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'button',
                    { className: 'btn-lrg-standard btn-white m-r-20', onClick: this.onCancelClick },
                    i18n.t('general.cancel')
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'button',
                    { className: 'btn-lrg-standard', onClick: this.onSaveClick },
                    i18n.t('general.update')
                ),
                showError && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'div',
                    { className: 'error-container' },
                    this.state.errorText
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                allowEditing = _props.allowEditing;


            var showOneliner = hasOneliner(user.one_liner) || allowEditing,
                userRatingsCount = parseInt(user.ratings_count, 10),
                showRating = user.is_seller && user.ratings_count > 0,
                showError = this.state.mode === 'error' && this.state.errorText !== '',
                showEdit = this.state.mode === 'edit' || this.state.mode === 'error';

            return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'div',
                { className: 'oneliner-wrapper' + (showEdit ? ' edit-mode' : '') + (showError ? ' error-mode' : '') + (!showRating ? ' no-rating' : '') },
                showOneliner && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'small',
                    { className: 'oneliner' },
                    this.state.oneliner
                ),
                allowEditing && this.renderEditIcon(),
                showEdit && this.renderEditForm(),
                showRating && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'div',
                    { className: 'ratings-wrapper' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('span', { className: 'star-rating-s15 rate-' + Math.round(user.rating * 2), 'data-user-rating': user.rating, 'data-user-ratings-count': user.ratings_count }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                        'p',
                        { className: 'rating-text' },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                            'strong',
                            null,
                            user.rating.toFixed(1)
                        ),
                        ' ',
                        '(' + i18n.t('seller_card.num_reviews', { count: userRatingsCount < 1000 ? userRatingsCount : '1k+' }) + ')'
                    )
                )
            );
        }
    }]);

    return Oneliner;
}(external___commonjs___react___commonjs2___react___amd___react___root___React__["Component"]);

oneliner_Oneliner.propTypes = {
    user: prop_types_default.a.object.isRequired,
    allowEditing: prop_types_default.a.bool.isRequired,
    authToken: prop_types_default.a.string.isRequired
};

/* harmony default export */ var oneliner = (oneliner_Oneliner);
// EXTERNAL MODULE: ./src/components/buttons/style.scss
var buttons_style = __webpack_require__("Bdlu");
var buttons_style_default = /*#__PURE__*/__webpack_require__.n(buttons_style);

// CONCATENATED MODULE: ./src/components/buttons/index.js
var buttons__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function buttons__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function buttons__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function buttons__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var VIEW_AS_BUYER_QUERY = 'view_as_buyer',
    VIEW_AS_SELLER_QUERY = 'view_as_seller';

/**
 * @class
 * @name Buttons
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} isMobileResponsive - mobile responsive or not
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {Boolean} viewingAsBuyer - whether the seller is viewing their page as a buyer
 * @param {Boolean} isCurrentUser - whether the user is currently logged in
 * @param {Boolean} showCustomOrder - whether we should show the custom order button (if applicable)
 * Container for rendering markup of the contact/custom order buttons
 */

var buttons_Buttons = function (_Component) {
    buttons__inherits(Buttons, _Component);

    function Buttons(props) {
        buttons__classCallCheck(this, Buttons);

        var _this = buttons__possibleConstructorReturn(this, (Buttons.__proto__ || Object.getPrototypeOf(Buttons)).call(this, props));

        _this.onContactClick = _this.onContactClick.bind(_this);
        _this.onViewAsClick = _this.onViewAsClick.bind(_this);
        return _this;
    }

    buttons__createClass(Buttons, [{
        key: 'onContactClick',
        value: function onContactClick() {
            // NOTE: MixpanelWrapper is instantiated in v2
            if (typeof MixpanelWrapper !== 'undefined') {
                MixpanelWrapper.bindLink(this.contactBtn, MixpanelWrapper.Events.ConversationEvents.CLICKED_CONTACT_ME);
            }
        }
    }, {
        key: 'onViewAsClick',
        value: function onViewAsClick(e) {
            e.preventDefault();
            var viewingAsBuyer = this.props.viewingAsBuyer;

            var queryType = viewingAsBuyer ? VIEW_AS_BUYER_QUERY : VIEW_AS_SELLER_QUERY,
                cleanLocation = window.location.href.split(/[?#]/)[0];
            window.location.href = cleanLocation + '?' + queryType + '=true';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                user = _props.user,
                isMobileResponsive = _props.isMobileResponsive,
                allowEditing = _props.allowEditing,
                viewingAsBuyer = _props.viewingAsBuyer,
                isCurrentUser = _props.isCurrentUser,
                showCustomOrder = _props.showCustomOrder,
                inWhitingContactButton = _props.inWhitingContactButton;


            var contactCls = void 0,
                contactSingle = false,
                orderCls = void 0,
                showContact = user.live_gigs && user.live_gigs.length > 0 && (!user.is_on_vacation || user.is_on_vacation && user.allow_contact),
                showCustomOrderValid = showCustomOrder && user.is_seller && user.custom_orders_allowed && !allowEditing;

            // if user is viewing their own page in the seller view,
            // we don't show the "contact me"-button

            if (allowEditing && !viewingAsBuyer) {
                showContact = false;
            }

            var contactLink = user.contact_path || '/conversations/' + user.username,
                orderLink = '/custom_orders/request/' + user.username + '/new',
                showViewAs = !isMobileResponsive && (allowEditing || viewingAsBuyer),
                viewAsString = i18n.t('seller_card.view_as_' + (viewingAsBuyer ? 'seller' : 'buyer'));

            if (user.is_spotlight) {
                showContact = false;
                showCustomOrderValid = false;
            }

            // if no buttons are shown, don't return the wrapper
            if (!showContact && !showCustomOrderValid && !showViewAs) {
                return null;
            }

            // if contact button is the only one shown, give it a special class
            if (showContact && !showCustomOrderValid && !showViewAs) {
                contactSingle = true;
            }

            if (isMobileResponsive) {

                contactCls = 'btn-standard btn-contact-me btn-green-grad m-b-15 fs-14';
                orderCls = 'btn-standard btn-custom-order m-b-15';
            } else {

                // TODO: "js-contact-me" is referenced in v2 (inside "popup-first-message.js"), needs to be updated
                // NOTE: "js-open-popup-login", "js-open-popup-join", "js-request-custom-order-button" are all bound to v2 JS functions
                contactCls = 'btn-lrg-standard btn-contact-me ' + (inWhitingContactButton ? 'btn-white' : '') + ' js-contact-me ' + (!isCurrentUser ? 'js-open-popup-login' : '') + ' ' + (contactSingle ? 'single-button' : '');
                orderCls = 'btn-lrg-standard btn-white btn-custom-order ' + (isCurrentUser ? 'js-request-custom-order-button' : 'js-open-popup-join');
            }

            return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'div',
                { className: 'buttons-wrapper' },
                showContact && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'a',
                    { href: contactLink, className: contactCls, onClick: this.onContactClick, ref: function ref(ele) {
                            _this2.contactBtn = ele;
                        }, rel: 'nofollow', 'data-user-id': user.username, 'data-redirect-url': contactLink },
                    i18n.t('seller_card.contact_me')
                ),
                showCustomOrderValid && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'a',
                    { href: orderLink, className: orderCls },
                    i18n.t('seller_card.custom_order')
                ),
                showViewAs && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'a',
                    { href: '#!', className: 'btn-lrg-standard btn-white btn-view-as', onClick: this.onViewAsClick },
                    viewAsString
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('div', { id: 'react-first-message-popup' })
            );
        }
    }]);

    return Buttons;
}(external___commonjs___react___commonjs2___react___amd___react___root___React__["Component"]);

buttons_Buttons.propTypes = {
    user: prop_types_default.a.object.isRequired,
    isMobileResponsive: prop_types_default.a.bool.isRequired,
    allowEditing: prop_types_default.a.bool.isRequired,
    viewingAsBuyer: prop_types_default.a.bool.isRequired,
    isCurrentUser: prop_types_default.a.bool.isRequired,
    showCustomOrder: prop_types_default.a.bool.isRequired
};

/* harmony default export */ var buttons = (buttons_Buttons);
// EXTERNAL MODULE: ./src/components/pro/style.scss
var pro_style = __webpack_require__("3XGG");
var pro_style_default = /*#__PURE__*/__webpack_require__.n(pro_style);

// CONCATENATED MODULE: ./src/components/pro/index.js




/**
 * @function
 * @name Pro
 * @param {Object} proCategories - the user's pro subcategories
 * Returns the markup of the user pro subcategories
 */

var pro_Pro = function Pro(_ref) {
    var proCategories = _ref.proCategories;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
        'div',
        { className: 'pro-wrapper' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'p',
            null,
            i18n.t('seller_card.pro.verified_by')
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'label',
            { className: 'pro-badge hint--left', 'data-hint': i18n.t('seller_card.pro.tooltip_seller') },
            i18n.t('general.pro')
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'ul',
            null,
            proCategories.map(function (subcategory, index) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'li',
                    { key: index },
                    subcategory.name
                );
            })
        )
    );
};

pro_Pro.propTypes = {
    proCategories: prop_types_default.a.array
};

/* harmony default export */ var pro = (pro_Pro);
// EXTERNAL MODULE: ./src/components/stats/style.scss
var stats_style = __webpack_require__("RIUQ");
var stats_style_default = /*#__PURE__*/__webpack_require__.n(stats_style);

// CONCATENATED MODULE: ./src/components/stats/index.js





/**
 * @function
 * @name Stats
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * Returns the markup of the seller stats
 */
var stats_Stats = function Stats(_ref) {
    var user = _ref.user,
        allowEditing = _ref.allowEditing,
        toggleVacation = _ref.toggleVacation,
        isOnVacation = _ref.isOnVacation;

    var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var showCountry = user.country && user.country.length > 0,


    // showLastDelivery = parseInt(user.recent_delivery, 10) > 0, // this is the correct way
    showLastDelivery = user.recent_delivery && user.recent_delivery.length > 0,
        // this is getting the wrong value from v2
    memberSinceDate = new Date(user.member_since * 1000),
        memberSince = monthNames[memberSinceDate.getMonth()] + ' ' + memberSinceDate.getFullYear();

    return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
        'ul',
        { className: 'user-stats' },
        showCountry && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'li',
            { className: 'location' },
            i18n.t('seller_card.from'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'strong',
                null,
                user.country
            )
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'li',
            { className: 'member-since' },
            i18n.t('seller_card.member_since'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'strong',
                null,
                memberSince
            )
        ),
        showResponseTime(user.response_time) && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'li',
            { className: 'response-time' },
            i18n.t('seller_card.response_time'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'strong',
                null,
                formatHoursAsDays(user.response_time)
            )
        ),
        showLastDelivery && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'li',
            { className: 'recent-delivery' },
            i18n.t('seller_card.recent_delivery'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'strong',
                null,
                user.recent_delivery
            )
        ),
        allowEditing && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
            'li',
            { className: 'vacation' },
            i18n.t('seller_card.out_of_office'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'div',
                { className: 'toggle-wrapper rf' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'label',
                    { onClick: toggleVacation, className: 'toggle-vacation' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('input', { type: 'checkbox', value: 'vacation', className: isOnVacation ? 'sel' : '', checked: isOnVacation }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement('div', { className: 'fake-toggle' })
                )
            )
        )
    );
};

stats_Stats.propTypes = {
    user: prop_types_default.a.object.isRequired,
    allowEditing: prop_types_default.a.bool.isRequired
};

/* harmony default export */ var stats = (stats_Stats);
// EXTERNAL MODULE: ./src/components/description/style.scss
var description_style = __webpack_require__("R5aA");
var description_style_default = /*#__PURE__*/__webpack_require__.n(description_style);

// CONCATENATED MODULE: ./src/components/description/index.js
var description__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function description__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function description__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function description__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var xss = __webpack_require__("NG4M");

/**
 * @class
 * @name Description
 * @extends Component
 * @param {String} userDescription - the seller's description
 * Container for rendering markup of the seller description
 */

var description_Description = function (_Component) {
    description__inherits(Description, _Component);

    function Description(props) {
        description__classCallCheck(this, Description);

        var _this = description__possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).call(this, props));

        _this.onReadMoreClick = _this.onReadMoreClick.bind(_this);

        _this.state = {
            descExpanded: false
        };
        return _this;
    }

    description__createClass(Description, [{
        key: 'onReadMoreClick',
        value: function onReadMoreClick(e) {
            e.preventDefault();

            this.setState({
                descExpanded: !this.state.descExpanded
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var desc = '';

            try {
                desc = xss(replaceBreakTags(this.props.userDescription), {
                    whiteList: [],
                    stripIgnoreTag: true,
                    stripIgnoreTagBody: ['script', 'a']
                });
            } catch (error) {
                // fail silently
            }

            var showReadMore = desc.length > 120;

            // if we stripped all tags, the description might now be empty
            if (desc.length > 0) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                    'footer',
                    { className: 'seller-desc ' + (this.state.descExpanded || !showReadMore ? 'expanded' : '') },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                        'div',
                        { className: 'inner' },
                        desc
                    ),
                    showReadMore && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                        'a',
                        { href: '#!', className: 'read-more', onClick: this.onReadMoreClick },
                        i18n.t('seller_card.read_more_text.' + (this.state.descExpanded ? 'less' : 'more'))
                    )
                );
            } else {
                return false;
            }
        }
    }]);

    return Description;
}(external___commonjs___react___commonjs2___react___amd___react___root___React__["Component"]);

description_Description.propTypes = {
    userDescription: prop_types_default.a.string
};

/* harmony default export */ var description = (description_Description);
// EXTERNAL MODULE: ./src/translations.en.json
var translations_en = __webpack_require__("eIBB");
var translations_en_default = /*#__PURE__*/__webpack_require__.n(translations_en);

// EXTERNAL MODULE: external "@fiverr/globals"
var globals_ = __webpack_require__("E4I8");
var globals__default = /*#__PURE__*/__webpack_require__.n(globals_);

// EXTERNAL MODULE: ./src/index.scss
var src = __webpack_require__("iCOP");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/SellerCard.js
var SellerCard__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SellerCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SellerCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SellerCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var SellerCard_SellerCard = function (_PureComponent) {
    SellerCard__inherits(SellerCard, _PureComponent);

    function SellerCard(props) {
        SellerCard__classCallCheck(this, SellerCard);

        var _this = SellerCard__possibleConstructorReturn(this, (SellerCard.__proto__ || Object.getPrototypeOf(SellerCard)).call(this, props));

        i18n.add(translations_en_default.a);

        _this.state = {
            isOnline: false,
            isOnVacation: props.user.is_on_vacation
        };

        _this.toggleVacation = _this.toggleVacation.bind(_this);
        return _this;
    }

    SellerCard__createClass(SellerCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (document) {
                document.addEventListener('popup_close', function () {
                    _this2.setState({
                        isOnVacation: false
                    });
                });

                document.addEventListener('out_of_office_on', function () {
                    _this2.setState({
                        isOnVacation: true
                    });
                });
            }

            var user = this.props.user;

            // this has a lot of checking to ensure this fails silently
            // when running in static or dev mode

            gofor('/users/' + user.username + '/is_online', {
                method: 'GET'
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response) {
                    _this2.setState({
                        isOnline: response.is_online === true
                    });
                }
            }).catch(function (err) {
                throw err;
            });
        }
    }, {
        key: 'toggleVacation',
        value: function toggleVacation(e) {
            var _this3 = this;

            e.preventDefault();
            e.stopPropagation();

            var user = this.props.user;


            if (this.state.isOnVacation) {
                gofor('/users/' + user.username + '/vacations', {
                    method: 'delete'
                }).then(function (response) {
                    if (response) {
                        var event = new CustomEvent('open_popup', { detail: false });
                        document.dispatchEvent(event);
                        _this3.setState({
                            isOnVacation: false
                        });
                    }
                }).catch(function (err) {
                    throw err;
                });
            } else {
                var event = new CustomEvent('open_popup', { detail: true });
                document.dispatchEvent(event);
                this.setState({
                    isOnVacation: true
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isOnline = _state.isOnline,
                isOnVacation = _state.isOnVacation;
            var _props = this.props,
                user = _props.user,
                allowEditing = _props.allowEditing,
                viewingAsBuyer = _props.viewingAsBuyer,
                isMobileResponsive = _props.isMobileResponsive,
                currentUser = _props.currentUser,
                showDescription = _props.showDescription,
                showCustomOrder = _props.showCustomOrder,
                authToken = _props.authToken,
                inWhitingContactButton = _props.inWhitingContactButton;


            var isCurrentUser = currentUser ? true : false,
                // eslint-disable-line
            neverLinkName = !showDescription,
                // when we're showing the description, we want to link the username as well
            allowEditingReal = allowEditing && !viewingAsBuyer,
                // if the user is in "buyer preview"-mode, editing is disabled
            showAmbassador = user.is_ambassador,
                showNow = user.is_now_seller,
                showDescriptionReal = showDescription && user.description && user.description.length > 0,
                showPro = user.is_pro && user.pro_sub_categories && !!user.pro_sub_categories.length;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(
                'div',
                { className: 'user-main-info' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(components_status, { isOnline: isOnline, userId: user.id, isOnVacation: isOnVacation }),
                (showAmbassador || showNow) && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(badges, { userName: user.username, showAmbassador: showAmbassador, showNow: showNow }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(profile_image, { user: user, allowEditing: allowEditingReal, authToken: authToken }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(profile_link, { userName: user.username, noLink: neverLinkName }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(oneliner, { user: user, allowEditing: allowEditingReal, authToken: authToken }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(buttons, { user: user, isMobileResponsive: isMobileResponsive, allowEditing: allowEditingReal, viewingAsBuyer: viewingAsBuyer, isCurrentUser: isCurrentUser, showCustomOrder: showCustomOrder, inWhitingContactButton: inWhitingContactButton }),
                showPro && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(pro, { proCategories: user.pro_sub_categories }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(stats, { user: user, allowEditing: allowEditingReal, isOnVacation: isOnVacation, toggleVacation: this.toggleVacation }),
                showDescriptionReal && external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(description, { userDescription: user.description })
            );
        }
    }]);

    return SellerCard;
}(external___commonjs___react___commonjs2___react___amd___react___root___React__["PureComponent"]);

SellerCard_SellerCard.propTypes = {
    user: prop_types_default.a.object.isRequired,
    allowEditing: prop_types_default.a.bool.isRequired,
    viewingAsBuyer: prop_types_default.a.bool.isRequired,
    isMobileResponsive: prop_types_default.a.bool.isRequired,
    currentUser: prop_types_default.a.object.isRequired,
    showDescription: prop_types_default.a.bool.isRequired,
    showCustomOrder: prop_types_default.a.bool.isRequired,
    authToken: prop_types_default.a.string
};

SellerCard_SellerCard.defaultProps = {
    user: {},
    allowEditing: false,
    viewingAsBuyer: false,
    isMobileResponsive: false,
    currentUser: {},
    showDescription: true,
    showCustomOrder: true,
    authToken: ''
};

/* harmony default export */ var src_SellerCard = (SellerCard_SellerCard);
// CONCATENATED MODULE: ./src/index.js




var componentElm = typeof document !== 'undefined' && document.getElementById('SellerCard-component');

if (componentElm) {
    var initialState = window.initialData.SellerCard;

    external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___default.a.render(external___commonjs___react___commonjs2___react___amd___react___root___React___default.a.createElement(src_SellerCard, initialState), componentElm);
}

/* harmony default export */ var src_0 = __webpack_exports__["default"] = (src_SellerCard);

/***/ }),

/***/ "noAI":
/***/ (function(module, exports) {

module.exports = {
  indexOf: function(arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function(arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function(str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function(str) {
    var reg = /\s|\n|\t/;
    var match = reg.exec(str);
    return match ? match.index : -1;
  }
};


/***/ }),

/***/ "oz9r":
/***/ (function(module, exports, __webpack_require__) {

/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS = __webpack_require__("0Zbq").FilterCSS;
var getDefaultCSSWhiteList = __webpack_require__("0Zbq").getDefaultWhiteList;
var _ = __webpack_require__("noAI");

function getDefaultWhiteList() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: ["autoplay", "controls", "loop", "preload", "src"],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height"],
    ins: ["datetime"],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: ["autoplay", "controls", "loop", "preload", "src", "height", "width"]
  };
}

var defaultCSSFilter = new FilterCSS();

/**
 * default onTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onTag(tag, html, options) {
  // do nothing
}

/**
 * default onIgnoreTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onIgnoreTag(tag, html, options) {
  // do nothing
}

/**
 * default onTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default onIgnoreTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onIgnoreTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default escapeHtml function
 *
 * @param {String} html
 */
function escapeHtml(html) {
  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}

/**
 * default safeAttrValue function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */
function safeAttrValue(tag, name, value, cssFilter) {
  // unescape attribute value firstly
  value = friendlyAttrValue(value);

  if (name === "href" || name === "src") {
    // filter `href` and `src` attribute
    // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
    value = _.trim(value);
    if (value === "#") return "#";
    if (
      !(
        value.substr(0, 7) === "http://" ||
        value.substr(0, 8) === "https://" ||
        value.substr(0, 7) === "mailto:" ||
        value.substr(0, 4) === "tel:" ||
        value[0] === "#" ||
        value[0] === "/"
      )
    ) {
      return "";
    }
  } else if (name === "background") {
    // filter `background` attribute (maybe no use)
    // `javascript:`
    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
      return "";
    }
  } else if (name === "style") {
    // `expression()`
    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
      return "";
    }
    // `url()`
    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
        return "";
      }
    }
    if (cssFilter !== false) {
      cssFilter = cssFilter || defaultCSSFilter;
      value = cssFilter.process(value);
    }
  }

  // escape `<>"` before returns
  value = escapeAttrValue(value);
  return value;
}

// RegExp list
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a)\:/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;

/**
 * escape doube quote
 *
 * @param {String} str
 * @return {String} str
 */
function escapeQuote(str) {
  return str.replace(REGEXP_QUOTE, "&quot;");
}

/**
 * unescape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function unescapeQuote(str) {
  return str.replace(REGEXP_QUOTE_2, '"');
}

/**
 * escape html entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeHtmlEntities(str) {
  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
    return code[0] === "x" || code[0] === "X"
      ? String.fromCharCode(parseInt(code.substr(1), 16))
      : String.fromCharCode(parseInt(code, 10));
  });
}

/**
 * escape html5 new danger entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeDangerHtml5Entities(str) {
  return str
    .replace(REGEXP_ATTR_VALUE_COLON, ":")
    .replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}

/**
 * clear nonprintable characters
 *
 * @param {String} str
 * @return {String}
 */
function clearNonPrintableCharacter(str) {
  var str2 = "";
  for (var i = 0, len = str.length; i < len; i++) {
    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
  }
  return _.trim(str2);
}

/**
 * get friendly attribute value
 *
 * @param {String} str
 * @return {String}
 */
function friendlyAttrValue(str) {
  str = unescapeQuote(str);
  str = escapeHtmlEntities(str);
  str = escapeDangerHtml5Entities(str);
  str = clearNonPrintableCharacter(str);
  return str;
}

/**
 * unescape attribute value
 *
 * @param {String} str
 * @return {String}
 */
function escapeAttrValue(str) {
  str = escapeQuote(str);
  str = escapeHtml(str);
  return str;
}

/**
 * `onIgnoreTag` function for removing all the tags that are not in whitelist
 */
function onIgnoreTagStripAll() {
  return "";
}

/**
 * remove tag body
 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
 *
 * @param {array} tags
 * @param {function} next
 */
function StripTagBody(tags, next) {
  if (typeof next !== "function") {
    next = function() {};
  }

  var isRemoveAllTag = !Array.isArray(tags);
  function isRemoveTag(tag) {
    if (isRemoveAllTag) return true;
    return _.indexOf(tags, tag) !== -1;
  }

  var removeList = [];
  var posStart = false;

  return {
    onIgnoreTag: function(tag, html, options) {
      if (isRemoveTag(tag)) {
        if (options.isClosing) {
          var ret = "[/removed]";
          var end = options.position + ret.length;
          removeList.push([
            posStart !== false ? posStart : options.position,
            end
          ]);
          posStart = false;
          return ret;
        } else {
          if (!posStart) {
            posStart = options.position;
          }
          return "[removed]";
        }
      } else {
        return next(tag, html, options);
      }
    },
    remove: function(html) {
      var rethtml = "";
      var lastPos = 0;
      _.forEach(removeList, function(pos) {
        rethtml += html.slice(lastPos, pos[0]);
        lastPos = pos[1];
      });
      rethtml += html.slice(lastPos);
      return rethtml;
    }
  };
}

/**
 * remove html comments
 *
 * @param {String} html
 * @return {String}
 */
function stripCommentTag(html) {
  return html.replace(STRIP_COMMENT_TAG_REGEXP, "");
}
var STRIP_COMMENT_TAG_REGEXP = /<!--[\s\S]*?-->/g;

/**
 * remove invisible characters
 *
 * @param {String} html
 * @return {String}
 */
function stripBlankChar(html) {
  var chars = html.split("");
  chars = chars.filter(function(char) {
    var c = char.charCodeAt(0);
    if (c === 127) return false;
    if (c <= 31) {
      if (c === 10 || c === 13) return true;
      return false;
    }
    return true;
  });
  return chars.join("");
}

exports.whiteList = getDefaultWhiteList();
exports.getDefaultWhiteList = getDefaultWhiteList;
exports.onTag = onTag;
exports.onIgnoreTag = onIgnoreTag;
exports.onTagAttr = onTagAttr;
exports.onIgnoreTagAttr = onIgnoreTagAttr;
exports.safeAttrValue = safeAttrValue;
exports.escapeHtml = escapeHtml;
exports.escapeQuote = escapeQuote;
exports.unescapeQuote = unescapeQuote;
exports.escapeHtmlEntities = escapeHtmlEntities;
exports.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
exports.clearNonPrintableCharacter = clearNonPrintableCharacter;
exports.friendlyAttrValue = friendlyAttrValue;
exports.escapeAttrValue = escapeAttrValue;
exports.onIgnoreTagStripAll = onIgnoreTagStripAll;
exports.StripTagBody = StripTagBody;
exports.stripCommentTag = stripCommentTag;
exports.stripBlankChar = stripBlankChar;
exports.cssFilter = defaultCSSFilter;
exports.getDefaultCSSWhiteList = getDefaultCSSWhiteList;


/***/ }),

/***/ "sfau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wLXD":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_wLXD__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.1afb7d870908ebdc8926.js